
export type GetUserStats404 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
